export const apiErrorParser = async <T>(error: T): Promise<{ orginal: T; parsed?: Error }> => {
  if ((error as any)?.status === 400) {
    try {
      const parsedError = await (error as any)?.json();

      if (
        parsedError?.errors &&
        parsedError?.errors instanceof Array &&
        (parsedError?.errors ?? [])[0]?.message &&
        typeof parsedError?.errors[0]?.message === "string"
      ) {
        return { orginal: error, parsed: new Error(parsedError?.errors[0]?.message) };
      }

      if (typeof parsedError?.detail === "string") {
        return { orginal: error, parsed: new Error(parsedError?.detail) };
      }

      return parsedError;
    } catch (jsonError: any) {
      return { orginal: error };
    }
  }

  return { orginal: error };
};
